export default class Script {
  static fromUrl (url) {
    let script = document.createElement('script')
    script.setAttribute('src', url)
    document.head.appendChild(script)
  }

  static fromCode (code) {
    let newScript = document.createElement('script')
    let inlineScript = document.createTextNode(code)
    newScript.appendChild(inlineScript)
    document.head.appendChild(newScript)
  }
}



// WEBPACK FOOTER //
// ./src/models/script.js